module.exports = __webpack_public_path__ + "static/media/sun.2e04b667.svg";